import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';

import { features } from '../../config';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const SAVE_NEWSLETTER_REQUEST = 'farmakom/newsletter/SAVE_NEWSLETTER_REQUEST';
const SAVE_NEWSLETTER_SUCCESS = 'farmakom/newsletter/SAVE_NEWSLETTER_SUCCESS';
const SAVE_NEWSLETTER_FAILURE = 'farmakom/newsletter/SAVE_NEWSLETTER_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------


// API CALL
export function saveNewsletter(email) {
    
    return {
        [RSAA]: {
            ...api.saveNewsletter(email),
            types: [SAVE_NEWSLETTER_REQUEST, SAVE_NEWSLETTER_SUCCESS, SAVE_NEWSLETTER_FAILURE]
        }
    }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
    loading: false,
    iscritto: false,
    error: ''
};

export default function newsletterReducer(state = initialState, action) {
    switch (action.type) {
        case SAVE_NEWSLETTER_REQUEST:
            return {
                ...state,
                loading: true,
                iscritto: false,
                error: ''
            }
        case SAVE_NEWSLETTER_SUCCESS:
            return {
                ...state,
                loading: false,
                iscritto: true
            }
        case SAVE_NEWSLETTER_FAILURE:
            return {
                ...state,
                loading: false,
                iscritto: false,
                error: action.payload
            }
        default:
            return state;
    }
}
